import * as Bls12381Multikey from '@digitalbazaar/bls12-381-multikey';
import { base58btc } from 'multiformats/bases/base58';
import { VerificationType } from '../../lib/types';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const generateBbs2023KeyPair = /* @__PURE__ */ __name(async ({ seed }) => {
  if (!seed) {
    throw new Error("Invalid seed");
  }
  const bbsKeyPair = await Bls12381Multikey.generateBbsKeyPair({
    algorithm: "BBS-BLS12-381-SHA-256",
    seed
  });
  const exportedKeys = await bbsKeyPair.export({
    publicKey: true,
    secretKey: true
  });
  const keyPair = {
    type: VerificationType.Multikey,
    seedBase58: base58btc.encode(seed).slice(1),
    secretKeyMultibase: exportedKeys.secretKeyMultibase,
    publicKeyMultibase: exportedKeys.publicKeyMultibase
  };
  return keyPair;
}, "generateBbs2023KeyPair");

export { generateBbs2023KeyPair };
